import * as React from 'react';

import { FormPasswordField } from 'components/inputs/FormPasswordField';
import { TextFieldProps } from 'ui';
import { getStrength } from '@tock/shared/utils/passwordHelpers';
import { useFormikContext } from 'formik';

const defaultHelperText =
  'Passwords must be at least 8 characters. Strong passwords have letters, numbers, and symbols.';

// Note: the strength.error should be in the validate function of the form.
export const FormValidatePasswordField: React.FunctionComponent<TextFieldProps> = ({
  helperText = defaultHelperText,
  ...rest
}) => {
  const formik = useFormikContext<{ password: string }>();
  const value = formik.values.password;
  const touched = formik.touched.password;
  const strength = getStrength(value);

  let warning;
  let valid;
  let error;

  if (strength) {
    warning = !!strength.warning && touched;
    valid = !!strength.valid && touched;
    error = !!strength.error && touched;
  }

  let helpText = helperText;
  if ((warning || valid || error) && touched) {
    helpText = strength.msg;
  }

  return (
    <FormPasswordField warn={warning || error} valid={valid} helperText={helpText} {...rest} />
  );
};
